/** Tombol Refresh: sync ulang dari waktu data terakhir s/d SEKARANG, tunggu selesai, reload. */
import { useState } from "react";

export function RefreshButton({ wing }: { wing: "media" | "social" }) {
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState("");
  async function go() {
    if (busy) return;
    setBusy(true); setNote("menyiapkan…");
    try {
      const t0 = Date.now();
      const lj = await fetch(`/api/v1/sync/latest?wing=${wing}`).then((r) => r.json()).catch(() => null);
      const lastMs = lj?.data?.lastPublishedAt ? new Date(lj.data.lastPublishedAt).getTime() : Date.now() - 86400e3;
      const wib = (ms: number) => new Date(ms + 7 * 3600e3).toISOString().slice(0, 10);
      const startDate = wib(lastMs), endDate = wib(Date.now());
      setNote(`sync ${startDate} → sekarang…`);
      const jobType = wing === "media" ? "dash" : "social";
      await fetch("/api/v1/sync", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ jobType, startDate, endDate, smart: false }) });
      // poll riwayat run sampai run baru (mulai setelah t0) selesai
      const vendorWant = wing === "media" ? "digivla" : "neticle";
      for (let i = 0; i < 60; i++) {
        await new Promise((res) => setTimeout(res, 3000));
        const rj = await fetch("/api/v1/sync?limit=10").then((r) => r.json()).catch(() => null);
        const runs: any[] = rj?.data ?? rj?.runs ?? [];
        const mine = runs.find((r) => r.vendor === vendorWant && new Date(r.startedAt).getTime() >= t0 - 10_000);
        if (mine && mine.status !== "running") { setNote("selesai — memuat ulang…"); location.reload(); return; }
        setNote(`sync berjalan… (${(i + 1) * 3}s)`);
      }
      setNote("timeout — memuat ulang…"); location.reload();
    } catch { setNote("gagal — coba lagi"); setBusy(false); }
  }
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "var(--space-4)" }}>
      {note && <span className="avio-t-sm avio-muted">{note}</span>}
      <button className="avio-btn" data-variant="secondary" data-size="sm" onClick={go} disabled={busy}
        title="Sync ulang dari data terakhir s/d sekarang" style={{ cursor: busy ? "wait" : "pointer" }}>
        <i className={busy ? "fa-solid fa-rotate fa-spin" : "fa-solid fa-rotate"} /> {busy ? "Sync…" : "Refresh"}
      </button>
    </span>
  );
}
